import React from 'react';
import type {QuestionModelV3} from '@albert-io/models';
import {setUpStore} from 'client/framework';

import TwoWayQuestionTable from './TwoWayQuestionTable.react';
import TwoWayQuesionStore from './TwoWayQuestion.store';

interface TwoWayQuestionProps {
  isGuessSubmitted?: boolean;
  storeName: string;
  question: QuestionModelV3;
  questionId?: string;
}

export default class TwoWayQuestion extends React.Component<TwoWayQuestionProps> {
  getStore() {
    return setUpStore(TwoWayQuesionStore, this.props.storeName, this.props.questionId);
  }

  render() {
    const {question, isGuessSubmitted} = this.props;
    return (
      /**
       * @todo: Drop `two-way-question` once legacy question renderers are gone
       */
      <div className='two-way-question twq-wrapper'>
        <TwoWayQuestionTable
          question={question}
          store={this.getStore()}
          isGuessSubmitted={isGuessSubmitted}
        />
      </div>
    );
  }
}
